import { cn } from "@-/com.npmjs.cn";
import { cva, type VariantProps } from "@-/com.npmjs.cva";
import type { ComponentProps } from "react";

const websiteSectionVariants = cva({
  // `isolate` keeps a section's `WebsiteGlow`s above its own background.
  base: "relative isolate",
  defaultVariants: {
    spacing: "default",
    tone: "paper",
  },
  variants: {
    spacing: {
      compact: "py-14 sm:py-20",
      default: "py-20 sm:py-28 lg:py-32",
      none: "",
    },
    tone: {
      canvas: "bg-website-canvas text-black",
      ink: "bg-website-ink text-white",
      paper: "bg-white text-black",
    },
  },
});

export type WebsiteSectionProps = ComponentProps<"section"> &
  VariantProps<typeof websiteSectionVariants>;

/**
 * A full-width band of the page. `WebsiteText`, `WebsiteEyebrow` and ghost buttons derive their
 * muted colors from the band's text color, so the same content reads correctly on every tone.
 */
export function WebsiteSection({ className, spacing, tone, ...props }: WebsiteSectionProps) {
  return (
    <section className={cn(websiteSectionVariants({ spacing, tone }), className)} {...props} />
  );
}
